import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.scss']
})

export class AnalysisComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Project Analysis - XipeTech';
  contentDescription = 'Discover XipeTech’s expert Project Analysis services. We deliver precise insights, identify challenges, and provide innovative IT solutions to ensure your projects succeed from start to finish.';
  contentKeywords = 'Project Analysis, Business Project Evaluation, IT Project Assessment, Data-Driven Insights, Project Optimization, XipeTech Solutions, Innovative Project Analytics, Project Performance Review, Strategic Project Planning, IT Consulting Services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
